/*import { CalendarDay } from "models/appointment-calendar-models";*/

export class CobpsCalendarModule {
    constructor() {
        if ($(".container-component__cobps-calendar").length > 0) {
            this.init();
        }
    }

    init() {
       

       // console.log(appointmentCalendarApp);

        //console.log('loaded');
    }
}